(function() {

	// Keep outdated browsers out by checking for Array.from function availability
	if (Array.from) {

		var productId = Array.from(document.querySelectorAll('#content a.productData')).map(function(product){
			return product.getAttribute("data-product");
		});

		productId = Array.from(new Set(productId));

		// Abort if we found no links on the content
		if(!productId[0]){
			return false;
		}

		// Define target API URL based on enviroment
		let API_DOMAIN;
		if(process.env.NODE_ENV === 'development'){
			API_DOMAIN = 'http://updt.cameratico.test';
		} else {
			API_DOMAIN = 'https://updt.cameratico.com';
		}

		// Fetch links
		axios.post(API_DOMAIN + '/getProductLink/', {
			'productId': productId.join(","),
			'url': document.documentURI
		})
		.then(response => {

			if(response.data.meta.error !== true){

				response.data.products.forEach(function(product){

						var targetLinksArray = Array.from(document.querySelectorAll('#content a.productData[data-product="' + product.productId + '"]')).map(function(link){

							if(link){

								link.classList.add('active');
								link.setAttribute('href', product.link);
								link.setAttribute('rel', 'nofollow');

								if(link.getAttribute("data-linkType") === 'image'){
									link.setAttribute('title', product.formattedPrice + ' at ' + product.storeName);
								} else {
									link.insertAdjacentHTML('beforeend', ' • <span class="price">' + product.formattedPrice + ' at ' + product.storeName + '</span>');
								}

							}

						});

				});

			}

		})
		.catch(error => {
		})

	} // Array.from check end

})();